import React from 'react';
import AddButton from './styles';

const AddFormButton = () => <AddButton href="/admin-panel">+</AddButton>;

export default AddFormButton;
